import React from "react";
import PropTypes from "prop-types";
import {FaSolidIcon} from "../../FontAwesomeIcons";
import {ServiceSearchResult} from "./ServiceSearchResult";

export class ServicesSearchView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            query: '',
        }
        this.categoriesById = {};
        this.categoryPathCache = {};
        this.rebuildCategoryIndex(this.props.categoriesList);
    }

    rebuildCategoryIndex = categories => {
        this.categoriesById = {};
        if (Array.isArray(categories)) {
            categories.forEach(category => {
                if (!category || category.id_categoria === undefined || category.id_categoria === null) return;
                const normalizedId = `${category.id_categoria}`;
                this.categoriesById[normalizedId] = category;
            });
        }
        this.categoryPathCache = {};
    }

    handleQueryChange = e => this.setState({query: e.target.value}, _ => {
        if (this.props.onSearchModeChange) this.props.onSearchModeChange(!!this.state.query);
    });
    handleResetQuery = e => this.setState({query: ''}, _ => {
        if (this.props.onSearchModeChange) this.props.onSearchModeChange(!!this.state.query);
    });

    getSearchResults = _ => {
        if (!this.state.query.trim()) return [];
        const keywords = this.state.query.trim().split(' ').map(k => k.trim().toLowerCase());
        return this.props.services.filter(s => keywords.every(k => s.nome.toLowerCase().indexOf(k) >= 0));
    }

    handleServiceSelectedChange = (id, selected) => {
        const ids = [...(this.props.selectedServiceIds || [])]
        if (selected) {
            ids.push(id)
        } else {
            const index = ids.findIndex(sid => sid == id);
            if (index > -1) {
                ids.splice(index, 1)
            }
        }
        this.props.onSelectedServicesChange(ids);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.categoriesList !== this.props.categoriesList) {
            this.rebuildCategoryIndex(this.props.categoriesList);
        }
    }

    getCategoryPath = categoryId => {
        if (!categoryId) return [];
        const normalizedId = `${categoryId}`;
        if (this.categoryPathCache[normalizedId]) {
            return this.categoryPathCache[normalizedId];
        }
        const path = [];
        const visitedIds = new Set();
        let currentId = normalizedId;
        while (currentId) {
            if (visitedIds.has(currentId)) break;
            visitedIds.add(currentId);
            const category = this.categoriesById[currentId];
            if (!category) break;
            path.unshift(category);
            const parentId =
                category.id_categoria_parent ??
                category.parent_id ??
                category.id_parent ??
                category.parentId ??
                null;
            if (parentId === undefined || parentId === null || `${parentId}` === '') {
                currentId = null;
            } else {
                currentId = `${parentId}`;
            }
        }
        this.categoryPathCache[normalizedId] = path;
        return path;
    }

    render() {
        const items = this.getSearchResults();
        return (
            <React.Fragment>
                <div className={"p-3 bg-main sticky-top"}>
                    <div className={"input-group"}>
                        <div className={"input-group-prepend"}>
                            <span className={"input-group-text bg-main-z3"}><FaSolidIcon name={"search"}/></span>
                        </div>
                        <input type={"text"}
                               className={`form-control border-left-0 ${!!this.state.query.trim() && 'border-right-0'}`}
                               onChange={this.handleQueryChange}
                               value={this.state.query} placeholder={"Cerca per nome..."}/>
                        {
                            !!this.state.query.trim() &&
                            <div className={"input-group-append bg-main-z3"}>
                                <button className={"btn btn-link text-muted border-top border-right border-bottom"}
                                        onClick={this.handleResetQuery}>
                                    <FaSolidIcon name={"times-circle"}/>
                                </button>
                            </div>
                        }
                    </div>
                </div>
                {
                    !!this.state.query.trim() &&
                    <div className={"px-3"}>
                        {
                            items.length === 0 &&
                            <div className={"py-5"}>
                                <p className={"lead"}>
                                    Non abbiamo trovato nulla con "{this.state.query.trim()}". Prova a utilizzare
                                    termini
                                    diversi.
                                </p>
                            </div>
                        }
                        {
                            items.map(s => {
                                return <ServiceSearchResult
                                    key={s.id_servizio}
                                    service={s}
                                    showPrices={this.props.showPrices}
                                    showDuration={this.props.showDuration}
                                    showImage={this.props.showImage}
                                    showDescription={this.props.showDescription}
                                    selected={(this.props.selectedServiceIds || []).some(id => id == s.id_servizio)}
                                    categoryPath={this.getCategoryPath(s.id_categoria || s.categoria)}
                                    onChange={this.handleServiceSelectedChange}
                                />
                            })
                        }
                    </div>
                }
            </React.Fragment>
        )
    }

}

ServicesSearchView.propTypes = {
    onSearchModeChange: PropTypes.func, //Tells the parent to switch to search mode
    onSelectedServicesChange: PropTypes.func, //Tells the parent to switch to service choose mode
    services: PropTypes.array,
    selectedServiceIds: PropTypes.arrayOf(PropTypes.any),
    showPrices: PropTypes.bool,
    showDescription: PropTypes.bool,
    showDuration: PropTypes.bool,
    showImage: PropTypes.bool,
    categoriesList: PropTypes.arrayOf(PropTypes.shape({
        id_categoria: PropTypes.any,
        id_categoria_parent: PropTypes.any,
        nome: PropTypes.string,
    })),
}
